import { PaymentResult } from '@core/models';
import {
	CheckoutPaymentInput,
	CheckoutPaymentPlan,
	CheckoutPaymentStrategy,
} from '../interfaces/checkout-payment.interface';
import { CheckoutPaymentPlanType } from '../enum/checkout-flow.enum';

export class CashPaymentStrategy implements CheckoutPaymentStrategy {
	prepare(input: CheckoutPaymentInput): CheckoutPaymentPlan {
		return { type: CheckoutPaymentPlanType.Cash, order: input.order };
	}

	acceptsResult(_result: PaymentResult): boolean {
		return true;
	}
}
